import React from 'react';
import { ActionCodeOperation } from 'firebase/auth';

import EmailActionConfirmBase from './EmailActionConfirmBase';

function VerifyEmailConfirm(props) {
  return (
    <EmailActionConfirmBase
      {...props}
      actionOperation={ActionCodeOperation.VERIFY_EMAIL}
      title='Verify email'
      checkingText='Checking this verification link...'
      applyingText='Verifying this email address...'
      successMessage='Your email address has been verified.'
      confirmLabel='Confirm'
      labels={{
        linkNoun: 'This verification link',
        actionNoun: 'Email verification',
      }}
      buildReadyCopy={(info) => (
        <>
          Verify <strong>{(info && info.data && info.data.email) || 'this email address'}</strong> for this account?
        </>
      )}
      buildSuccessCopy={(info) => (
        <>
          <strong>{(info && info.data && info.data.email) || 'This email address'}</strong> is now verified.
        </>
      )}
      buildMismatchMessage={() => 'This link is not for verifying an email address.'}
    />
  );
}

export default VerifyEmailConfirm;
